import { render, staticRenderFns } from "./DutyForm.vue?vue&type=template&id=106b36e4"
import script from "./DutyForm.vue?vue&type=script&lang=js"
export * from "./DutyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports